export const COLORS = {
  yellow: '#F6DF48',
  purple: '#746DEF',
  green: '#23D5AE',
  darkBlue: '#57608C'
}
